export const transmitRequestInfo = {
  bank: {
    name: "은행",
    data: `계좌(수신상품/투자상품/대출상품) 목록 : 고객정보 최초생성일, 계좌번호, 회차번호, 외화계좌여부, 상품명, 마이너스약정여부, 계좌구분, 계좌상태
    개인형IRP 계좌 목록 : 상품명, 계좌번호`,
  },
  card: {
    name: "카드",
    data: `카드 목록 : 카드 식별자, 카드번호, 카드상품명, 본인/가족구분, 카드 구분
	  대출상품 목록 : 단기대출(여부), 장기대출(여부)
	  선불카드 목록 : 선불카드 식별자, 선불카드 상품명, 발급일자, 액면한도 또는 최대충전한도`,
  },
  invest: {
    name: "금융투자",
    data: `계좌 목록 : 계좌번호, 계좌명, 계좌종류, 계좌개설일, 세제혜택 적용여부, CMA상품포함여부, 주식거래가능여부, 은행예수금방식계좌여부
    개인형IRP 계좌 목록 : 상품명, 계좌번호`,
  },
  insu: {
    name: "보험",
    data: `보험증권 목록 : 증권번호, 상품명, 보험종류 구분, 계약상태
    대출계좌 목록 : 상품명, 계좌번호, 계좌번호 별 구분코드, 계좌번호 별 상태 코드
    개인형IRP 계좌 목록 : 상품명, 계좌번호`,
  },
  efin: {
    name: "전자금융",
    data: `선불전자지급수단 목록 : 권면ID, 권면명, 가입일자, 권면한도, 자동충전 등록여부, 통화코드, 계정식별값
    계정 목록 : Sub key, 계정 식별값, 가입일, 결제수단 등록여부`,
  },
  capital: {
    name: "할부금융",
    data: `계좌(대출/운용리스) 목록 : 최초고객DB생성일, 계좌번호, 회차번호, 상품명, 계좌구분, 계좌상태`,
  },
  ginsu: {
    name: "보증보험",
    data: `보증보험 목록 : 증권번호, 상품명, 보험종류구분, 계약상태`,
  },
  telecom: {
    name: "통신",
    data: `통신 계약 목록 : 계약관리번호, 가입번호, 통신구분, 가입구분`,
  },
  p2p: {
    name: "P2P",
    data: `P2P 대출 목록 : 대출계약번호, 상품유형, 대출계약금액, 대출일`,
  },
  bond: {
    name: "인수채권",
    data: `인수채권/금전대부 목록 : 채권번호, 기관분류, 채권인수일(특수채권편입일/최초대출일), 최초대출기관`,
  },
  usury: {
    name: "대부",
    data: `인수채권/금전대부 목록 : 채권번호, 기관분류, 채권인수일(특수채권편입일/최초대출일), 최초대출기관`,
  },
};

export const dataDetailTerms2Info = {
  bank: {
    name: "은행",
    data: `수신계좌 정보 : 기본정보(통화코드, 저축방법, 계좌개설일자, 만기일, 약정액, 월 납입액), 추가정보(통화코드, 현재잔액, 출금가능액, 금리, 최종납입회차), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 거래구분, 통화코드, 거래금액, 거래 후 잔액, 납입회차, 적요)
	투자 상품 정보 : 기본정보(표준펀드코드, 납입유형, 개설일, 만기일), 추가정보(통화코드, 잔액, 평가금액, 투자원금, 보유좌수), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 통화코드, 기준가, 거래좌수, 거래금액, 거래 후 잔고평가금액)
	대출 상품 정보 : 기본정보(대출일, 만기일, 최종적용금리, 월상환일, 상환방식, 자동이체 기관, 상환계좌번호(자동이체), 거치기간 시작연월, 거치기간 종료연월, 추가정보(통화코드, 대출잔액, 대출원금, 다음 이자 상환일), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 통화코드, 거래금액, 거래 후 대출잔액, 거래금액 중 원금, 거래금액 중 이자, 환출이자, 이자적용시작일, 이자적용종료일, 적용이율, 이자금액, 이자종류)
	개인형 IRP 정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일시 또는 거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  card: {
    name: "카드",
    data: `카드 정보 : 기본정보(교통기능(여부), 현금카드기능(여부), 결제은행, 결제계좌번호, 카드브랜드, 상품 연회비, 발급일자), 승인내역(승인번호, 승인일시, 결제상태, 사용구분(신용/체크), 정정 또는 승인취소 일시, 가맹점명, 가맹점 사업자등록번호, 이용금액, 정정 후 금액, [국내승인]전체 할부회차, 결제(승인)국가코드, [해외승인]결제(승인) 시 통화코드, [해외승인]원화), 매입(취소)내역(매입번호, 매입일자, 매출(취소)일자, 원승인번호, 원승인일시, 원승인금액(원화), 사용구분(신용/체크), 가맹점명, [국내매입]가맹점 사업자등록번호, 이용금액, [국내매입]전체 할부회차, [해외매입]원승인금액통화코드, [해외매입]결제(매입)국가코드, [해외매입]결제(매입)시 통화코드, [해외매입]원화)
	선불카드 정보 : 잔액정보(총잔액, 충전포인트 잔액, 적립포인트 잔액, 적립예정, 소멸예정), 거래내역(거래유형, 거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 잔액, 거래상대기관, 거래상대 식별값), 승인내역(승인일시, 승인번호, 결제상태, 정정 또는 승인취소 일시, 가맹점명, 가맹점 사업자등록번호, 이용금액, 정정 후 금액, 전체 할부회차)
	포인트 정보 : 포인트명, 잔여포인트, M+2월 소멸예정 포인트
	청구 · 결제 정보 및 리볼빙 정보 : 청구기본정보(결제순번, 월별 청구금액, 결제일, 청구년월, 결제년월일), 청구추가정보(카드 식별자, 사용일시 또는 사용일자, 거래번호, 이용금액, 통화코드(이용금액), 가맹점명, 가맹점 사업자등록번호, 신용판매 수수료, 전체 할부회차, 현재 할부회차, 할부 결제 후 잔액, 상품구분), 결제정보(리볼빙(여부), 결제순번, 결제예정일, 결제예정금액, 일시불, 할부, 단기대출(현금서비스), 리볼빙, 장기대출(카드론, 신용대출), 연회비 및 기타), 리볼빙 정보(리볼빙 약정 시작일, 리볼빙 약정 종료일, 리볼빙 해지일자, 최소결제비율, 최소결제금액, 약정결제비율, 약정결제금액, 리볼빙 이월잔액)
	대출상품 정보 : 단기대출(이용일시, 이용금액, 단기대출 잔액, 결제예정일, 이자율, 상환기관, 상환계좌번호), 장기대출(대출번호, 대출일시 또는 대출일자, 일자의 대출회차, 대출종류, 상품명, 이용금액, 이자율, 만기일, 장기대출 잔액, 상환방법, 상환액 중 이자, 상환기관, 상환계좌번호), 장기대출 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 통화코드, 거래금액, 거래 후 대출잔액, 거래금액 중 원금, 거래금액 중 이자)`,
  },
  invest: {
    name: "금융투자",
    data: `계좌 정보 : 기본정보(통화코드, 예수금, 신용융자, 대출금, 출금가능금액), 거래내역(종목명(상품명), 종목코드(상품코드), 거래일시 또는 거래일자, 거래번호, 거래종류, 거래종류 상세, 거래수량, 수량단위명, 거래단가, 거래금액, 정산금액, 거래 후 잔액, 통화코드, 적요, 거래소 코드), 
  상품 정보: 기본정보(상품종류, 상품종류 상세, 종목코드(상품코드), 거래소 코드, 종목명, 파생상품포지션구분, 신용구분, 세제혜택 적용여부(상품), 매입금액, 보유수량, 수량단위명, 평가금액, 체결기준여부, 통화코드)
  연금계좌 정보: 연금계좌 추가정보(연금가입일, 납부총액, 기출금액, 최종납입일, 연금기수령액, 연금개시(예정)일, 금년납입금, 통화코드)
	개인형 IRP 정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일시 또는 거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  insu: {
    name: "보험",
    data: `보험 정보 : 기본정보(갱신여부, 계약체결일, 만기일자, 보험가입금액, 통화코드(보험가입금액), 변액보험여부, 유니버셜여부, 연금개시일, 연금수령주기, 대출실행가능상품여부, 피보험자수, 피보험자번호, 피보험자명, 주피보험자여부), 특약정보(특약명, 특약의 상태, 특약만기일자, 특약가입금액, 통화코드(특약가입금액), 특약의 유형(여부)), 자동차보험 정보(차량번호, 자동차보험구분, 계약자차량명, 보험시기, 보험종기, 연령특약, 운전자한정특약, 자기차량손해(여부), 자기부담금구분, 자기부담금금액), 납입정보(납입기간구분, 납입주기, 총납입횟수, 납입기관, 납입계좌번호(자동이체), 납입일자, 납입종료일자, 납입보험료, 통화코드(납입보험료), 자동대출납입신청여부), 거래내역(납입일자, 납입연월, 납입회차, 실납입보험료, 통화코드(실납입보험료), 수금방법), 자동차보험 거래내역(거래일시 또는 거래일자, 거래번호, 자동차보험보험료, 납입회차, 실납입보험료, 수금방법, 납입기관, 납입 계좌번호), 보장정보(계약관계자구분, 피보험자계약자관계, 담보상태, 담보, 담보특성, 회사담보일렬번호, 회사담보명, 담보금액, 담보기간시작일자, 담보기간종료일자)
		대출상품 정보 : 기본정보(대출일, 만기일, 상환방식, 증권번호, 납입기관, 납입계좌번호(자동이체), 월상환일), 추가정보(통화코드, 대출잔액, 대출원금, 다음 이자 상환일), 거래내역(거래번호, 거래일시 또는 거래일자, 통화코드, 대출원금상환액, 이자납입액, 이자적용시작일, 이자적용종료일, 적용이율, 이자종류)
		개인형 IRP 정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일시 또는 거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  efin: {
    name: "전자금융",
    data: `선불전자지급수단 정보 : 잔액정보(총잔액, 충전포인트 잔액, 적립포인트 잔액, 출금 가능액, 적립예정, 소멸예정), 자동충전정보(충전지불수단기관, 충전지불수단식별키, 충전조건, 기준날짜, 기준금액, 충전금액), 선불거래내역(거래유형, 거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 잔액, 거래상대기관, 거래상대식별값, 주문번호, 거래메모, 가맹점명, 가맹점사업자등록번호, 상품(구매)제목, 상품(구매)분류, 결제방법, 정기결제여부)
	결제 정보 : 결제수단등록정보(결제수단기관, 결제수단식별코드, 결제수단식별키, Primary여부), 결제내역(결제유형, 주문번호, 결제일시 또는 결제취소일시, 결제번호, 통화코드, 결제금액, 결제수단 기관, 결제수단 식별코드, 결제수단 식별키, 카드승인번호, 카드명, 할부개월, 거래메모, 가맹점명, 가맹점 사업자등록번호, 상품(구매)제목, 상품(구매)분류, 결제방법)`,
  },
  capital: {
    name: "할부금융",
    data: `대출상품 또는 운용리스 정보 : 기본정보(대출일, 만기일, 최종적용금리, 월상환일, 상환방식, 자동이체기관, 상환계좌번호(자동이체)), 추가정보(통화코드, 대출잔액, 대출원금, 다음이자상환일), 거래내역(거래일시, 거래번호, 거래유형, 통화코드, 거래금액, 거래 후 대출잔액, 거래금액 중 원금, 거래금액 중 이자, 환출이자, 이자적용시작일, 이자적용종료일, 적용이율, 이자금액, 이자종류), 운용리스기본정보(대출일, 반기일, 월상환일, 상환방식, 자동이체기관, 상환계좌번호, 다음납입예정일), 운용리스 거래내역(거래일시, 거래번호, 거래유형, 거래금액)`,
  },
  ginsu: {
    name: "보증보험",
    data: `보증보험 정보 : 기본정보(계약체결일, 종료일자, 보험가입금액, 피보험자수, 피보험자목록, 피보험자명, 납입기간구분, 총납입보험료), 거래내역(납입일자, 납입회차, 실납입보험료, 수금방법)`,
  },
  telecom: {
    name: "통신",
    data: `통신 정보 : 청구정보(청구연월, 청구금액, 납부예정일자), 거래내역(납부연월, 납부금액, 납부수단), 결제내역(이용일시, 결제금액, 가맹점사업자번호, 가맹점명, 결제상품명)`,
  },
  p2p: {
    name: "P2P",
    data: `P2P 대출 정보 : 기본정보(만기일, 대출금리, 상환방식, 부동산담보 LTV비율), 추가정보(대출잔액, 다음상환회차, 다음상환일, 예정원금, 예정이자), 거래내역(상환일시, 상환회차, 상환유형, 상환금액, 상환금액 중 원금, 상환금액 중 이자)`,
  },
  bond: {
    name: "인수채권",
    data: `인수채권/금전대부 정보 : 잔액정보(직전채권인계기관, 채무조정 여부, 상환방식, 대출잔액, 대출원금), 거래내역(거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 대출잔액, 거래금액 중 이자, 거래금액 중 원금)`,
  },
  usury: {
    name: "대부",
    data: `인수채권/금전대부 정보 : 잔액정보(직전채권인계기관, 채무조정 여부, 상환방식, 대출잔액, 대출원금), 거래내역(거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 대출잔액, 거래금액 중 이자, 거래금액 중 원금)`,
  },
};

export const dataEachInfo = {
  bank: {
    name: "은행",
    data: `계좌(수신상품/투자상품/대출상품) 목록 : 고객정보 최초생성일, 계좌번호, 회차번호, 상품명, 마이너스약정여부, 외화계좌여부, 계좌구분, 계좌상태, 적요전송요구여부
	수신계좌 정보 : 기본정보(통화코드, 저축방법, 계좌개설일자, 만기일, 약정액, 월 납입액), 추가정보(통화코드, 현재잔액, 출금가능액, 적용금리, 최종납입회차), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 거래구분,  통화코드, 거래금액, 거래 후 잔액, 납입회차 ,적요) 
	투자 상품 정보 : 기본정보(표준펀드코드, 납입유형, 개설일, 만기일), 추가정보(통화코드, 잔액, 평가금액,  투자원금, 보유좌수), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 통화코드, 기준가, 거래좌수, 거래금액, 거래 후 잔고평가금액)
	대출 상품 정보 : 기본정보(대출일, 만기일, 최종적용금리, 월상환일, 상환방식, 자동이체 기관, 상환계좌번호(자동이체)), 추가정보(통화코드, 대출잔액, 대출원금, 다음 이자 상환일), 거래내역(거래일시 또는 거래일자, 거래번호, 거래유형, 통화코드, 거래금액, 거래 후 대출잔액, 거래금액 중 원금, 거래금액 중 이자, 환출이자, 이자적용시작일, 이자적용종료일, 작용이율, 이자금액, 이자종류)
	개인형IRP 계좌 목록 : 상품명, 계좌번호
	개인형 IRP  정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  card: {
    name: "카드",
    data: `카드 목록 : 카드 식별자, 카드번호, 카드상품명, 본인/가족구분, 카드 구분
	카드 정보 : 기본정보(교통기능(여부), 한금카드기능(여부), 결제은행, 카드브랜드, 상품 연회비, 발급일자), 승인내역(승인번호, 승인일시, 결제상태, 사용구분(신용/체크), 정정 또는 승인취소 일시, 가맹점명, 가맹점 사업자등록번호, 이용금액, 정정 후 금액, 전체 할부회차, 결제(승인)국가코드, 결제(승인) 시 통화코드, 원화)
	선불카드 목록 : 선불카드 식별자, 선불카드 상품명, 발급일자 또는 기명일자, 액면한도 또는 최대충전한도
	선불카드 정보 : 전액정보(총잔액, 충전포인트 잔액, 적립포인트 잔액, 적립예정, 소멸예정), 거래내역(거래유형, 거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 잔액, 거래상대기관, 거래상대 식별값), 승인내역(승인일시, 승인번호, 결제상태, 정정 또는 승인취소 일시, 가맹점명, 가맹점 사업자등록번호, 이용금액, 정정 후 금액, 전체 할부회차)
	포인트 정보 : 포인트명, 잔여포인트, M+2월 소멸예정 포인트
	청구 · 결제 정보 및 리볼빙 정보 : 청구기본정보(결제순번, 월별 청구금액, 결제일, 청구년월, 결제년월일), 청구추가정보(카드 식별자, 사용일시 또는 사용일자, 거래번호, 이용금액, 통화코드, 가맹점명, 가맹점 사업자등록번호, 신용판매 수수료, 전체 할부회차, 현재 할부회차, 할부 결제 후 잔액, 상품구분), 결제정보(결제순번, 결제예정일, 결제예정금액), 리볼빙 정보(신청일, 최소결제비율, 최소결제금액, 약정결제비율, 약정결제금액, 리볼빙 이월잔액)
	대출상품 목록 : 단기대출(여부), 장기대출(여부)
	대출상품 정보 : 단기대출(이용일시, 이용금액, 단기대출 잔액, 결제예정일, 이자율), 장기대출(대출일시 또는 대출일자, 일자의 대출회차, 대출종류, 상품명, 이용금액, 이자율, 만기일, 장기대출 잔액, 상환방법, 상환액 중 이자)`,
  },
  invest: {
    name: "금융투자",
    data: `계좌 목록 : 계좌번호, 계좌명, 계좌종류, 계좌개설일, 세제혜택적용여부(계좌)
	계좌 정보 : 기본정보(통화코드, 예수금, 신용융자, 대출금), 거래내역(종목명(상품명), 종목코드(상품코드), 거래일시 또는 거래일자, 거래번호, 거래종류, 거래종류 상세, 거래수량, 거래단가, 거래금액, 정산금액, 거래 후 잔액, 통화코드, 해외주식 거래소 코드), 상품정보(상품종류, 상품종류 상세, 종목코드, 해외주식 거래소 코드, 종목명, 파생상품포지션구분, 신용구분, 세제혜택 적용여부(상품), 매입금액, 보유수량, 평가금액, 통화코드, 연금계좌 추가정보(연금가입일, 납부총액, 기출금액, 최종납입일, 연금기수령액)
	개인형IRP 계좌 목록 : 상품명, 계좌번호
	개인형 IRP  정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  insu: {
    name: "보험",
    data: `보험증권 목록 : 증권번호, 상품명, 보험종류구분, 계약상태
	보험 정보 : 기본정보(갱신여부, 계약체결일, 만기일자, 보험가입금액, 통화코드(보험가입금액), 변액보험여부, 유니버셜여부, 연금개시일, 연금수령주기, 대출실행가능상품여부, 피보험자수, 피보험자번호, 피보험자명, 주피보험자여부), 특약정보(특약명, 특약의 상태, 특약만기일자, 특약가입금액, 통화코드(특약가입금액), 특약의 유형),자동차보험 정보(차량번호, 자동차보험구분, 계약자차량명, 보험시기, 보험종기, 연령특약, 운전자한정특약, 자기차량손해(여부), 자기부담금구분, 자기부담금금액), 납입정보(납입기간구분, 납입주기, 총납입횟수, 납입기관, 납입일자, 납입종료일자, 납입보험료, 통화코드(납입보험료), 자동대출납입신청여부), 거래내역(납입일자, 납입연월, 납입회차, 실납입보험료, 통화코드(실납입보험료), 수금방법), 자동차보험 거래내역(거래일시 또는 거래일자, 거래번호, 자동차보험보험료, 납입회차, 실납입보험료, 수금방법), 보장정보(계약관계자구분, 피보험자계약자관계, 담보상태, 담보, 담보특성, 회사담보일렬번호, 회사담보명, 담보금액, 담보기간시작일자, 담보기간종료일자)
	대출계좌 목록 : 상품명, 계좌번호, 계좌번호 별 구분코드, 계좌번호 별 상태 코드
	대출상품 정보 : 기본정보(대출일, 만기일, 상환방식, 증권번호), 추가정보(통화코드, 대출잔액, 대출원금, 다음 이자 상환일), 거래내역(거래번호, 거래일시 또는 거래일자, 통화코드, 대출원금상환액, 이자납입액, 이자적용시작일, 이자적요종료일, 적요이율, 이자종류)
	개인형IRP 계좌 목록 : 상품명, 계좌번호
	개인형 IRP  정보 : 기본정보(계좌잔액, 계좌평가금액, 사용자부담금, 가입자부담금, 개설일, 최초입금일, 최초제도가입일, 연금개시시작(예정)일), 추가정보(개별운용상품명, 상품가입번호, 상품유형, 평가금액, 납입(투자)원금, 보유좌수, 신규일, 만기일, 약정이자율), 거래내역(거래일자, 거래번호, 거래구분, 거래금액)`,
  },
  efin: {
    name: "전자금융",
    data: `선불전자지급수단 목록 : 권면ID, 권면명, 권면한도, 자동충전 등록여부, 통화코드, 계정 식별값
	선불전자지급수단 정보 : 잔액정보(총잔액, 충전포인트 잔액, 적립포인트 잔액, 적립예정, 소멸예정). 자동충전정보(충전지불수단기관, 충전지불수단식별키, 충전조건, 기준날짜, 기준금액, 충전금액), 선불거래내역(거래유형, 거래일자, 거래번호, 거래금액, 거래 후 잔액, 거래상대기관, 거래상대식별값, 거래메모, 가맹점명, 상품(구매)제목, 상품(구매)분류, 결제방법)
	계정 목록 : subkey, 계정 식별값, 가입일, 결제수단 등록여부
	결제 정보 : 결제수단등록정보(결제수단기관, 결제수단식별키, Primary여부), 결제내역(결제유형, 주문번호, 결제일시(결제취소일시), 결제번호, 통화코드, 결제금액, 결제수단기관, 결제수단식별키, 할부개월, 거래메모, 가맹점명, 가맹점사업자등록번호, 상품(구매)제목, 상품(구매)분류, 결제방법)`,
  },
  capital: {
    name: "할부금융",
    data: `계좌(대출/운용리스) 목록 : 최초고객DB생성일, 계좌번호, 회차번호, 상품명, 계좌구분, 계좌상태
	대출상품 또는 운용리스 정보 : 기본정보(대출일, 만기일, 최종적용금리, 월상환일, 상환방식, 자동이체기관, 상환계좌번호(자동이체)), 추가정보(통화코드, 대출잔액, 대출원금, 다음이자상환일), 거래내역(거래일시, 거래번호, 거래유형, 통화코드, 거래금액, 거래 후 대출잔액, 거래금액 중 원금, 거래금액 중 이자, 환출이자, 이자적용시작일, 이자적용종료일, 적용이율, 이자금액, 이자종류), 운용리스기본정보(대출일, 반기일, 월상환일, 상환방식, 자동이체기관, 상환계좌번호, 다음납입예정일), 운용리스 거래내역(거래일시, 거래번호, 거래유형, 거래금액)`,
  },
  ginsu: {
    name: "보증보험",
    data: `보증보험 목록 : 증권번호, 상품명, 보험종류구분, 계약상태
	보증보험 정보 : 기본정보(계약체결일, 종료일자, 보험가입금액, 피보험자수, 피보험자목록, 피보험자명, 납입기간구분, 총납입보험료), 거래내역(납입일자, 납입회차, 실납입보험료, 수금방법)`,
  },
  telecom: {
    name: "통신",
    data: `통신 계약 목록 : 계약관리번호, 가입번호, 통신구분, 가입구분
	통신 정보 : 청구정보(청구금액, 납부예정일자), 거래내역(납부연월, 납부금액, 납부수단), 결제내역(이용일시, 결제금액, 가맹점명, 결제상품명)`,
  },
  p2p: {
    name: "P2P",
    data: `P2P 대출 목록 : 대출계약번호, 상품유형, 대출계약금액, 대출일
	P2P 대출 정보 : 기본정보(만기일, 대출금리, 상환방식, 부동산담보 LTV비율), 추가정보(대출잔액, 다음상환회차, 다음상환일, 예정원금, 예정이자), 거래내역(상환일시, 상환회차, 상환유형, 상환금액, 상환금액 중 원금, 상환금액 중 이자)`,
  },
  bond: {
    name: "인수채권",
    data: `인수채권/금전대부 목록 : 채권번호, 기관분류, 채권인수일(특수채권편입일/최초대출일), 최초대출기관
	인수채권/금전대부 정보 : 잔액정보(직전채권인계기관, 채무조정 여부, 상환방식, 대출잔액, 대출원금), 거래내역(거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 대출잔액, 거래금액 중 이자, 거래금액 중 원금)`,
  },
  loan: {
    name: "대부",
    data: `인수채권/금전대부 목록 : 채권번호, 기관분류, 채권인수일(특수채권편입일/최초대출일), 최초대출기관
	인수채권/금전대부 정보 : 잔액정보(직전채권인계기관, 채무조정 여부, 상환방식, 대출잔액, 대출원금), 거래내역(거래일시 또는 거래일자, 거래번호, 거래금액, 거래 후 대출잔액, 거래금액 중 이자, 거래금액 중 원금)`,
  },
};
